import en from './en/messages.json';
import fr from './fr/messages.json';

const translations = {
  en: en,
  fr: fr,
};

export default translations;
